module.exports = __webpack_public_path__ + "media/img/corporate/logos/abb-3f1e1e301a536958f26f8c9c707f198b.svg";